
const ImdFeedConfigurations = require('../conf/imd-feeds-configurations.json');

class Feed{

  constructor (feed, hash, lang) {
    this.name = feed.name;
    this.ignoreOnStartUp = !!feed.ignoreOnStartUp;
    this.localized = !!feed.localized;
    this.params = feed.params || {};

    this.url_client = `/${hash}/api${feed.path}` +
      (feed.localized ? `?lang=${lang ? lang : 'MISSING'}` : '');

    this._feed = feed;
    this._hash = hash;
  }

  withLang (lang) {
    return new Feed(this._feed, this._hash, lang);
  }
}

function getFeeds (imdHash) {
  return ImdFeedConfigurations.map(feed => new Feed(feed, imdHash));
}

module.exports = {
  getFeeds: getFeeds
};
